import { PageHeader } from './components/PageHeader';
import { Monitor } from './components/Monitor';

function App() {
    return (
        <PageHeader currentPath="/">
            <Monitor />
        </PageHeader>
    );
}

export default App;
